import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SidebarState {
  isCollapsed: boolean;
}

const initialState: SidebarState = {
  isCollapsed: (() => {
    try {
      const stored = localStorage.getItem('sidebar-collapsed');
      return stored ? JSON.parse(stored) : false;
    } catch {
      return false;
    }
  })(),
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isCollapsed = !state.isCollapsed;
      localStorage.setItem(
        'sidebar-collapsed',
        JSON.stringify(state.isCollapsed),
      );
    },
    collapseSidebar: (state) => {
      state.isCollapsed = true;
      localStorage.setItem('sidebar-collapsed', JSON.stringify(true));
    },
    expandSidebar: (state) => {
      state.isCollapsed = false;
      localStorage.setItem('sidebar-collapsed', JSON.stringify(false));
    },
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isCollapsed = action.payload;
      localStorage.setItem('sidebar-collapsed', JSON.stringify(action.payload));
    },
  },
});

export const {
  toggleSidebar,
  collapseSidebar,
  expandSidebar,
  setSidebarCollapsed,
} = sidebarSlice.actions;

export const sidebarIsCollapsedSelector = (state: PropSavyRootState) =>
  state.sidebar.isCollapsed;

export default sidebarSlice.reducer;
